var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-approver clearfix"},_vm._l((_vm.moderationStatuses),function(status){return _c('moderation-status',{key:status,attrs:{"status":status,"label":_vm.labels[status],"name":_vm.name},model:{value:(_vm.currentStatus),callback:function ($$v) {_vm.currentStatus=$$v},expression:"currentStatus"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }